const listPermissionNameComponent = {
  AllSite: "add-advertise",
  AddSite: "add-advertise",
  InfoSite: "add-advertise",

  AllUser: "view-all-user",

  ManageAllPublisher: "view-all-user",
  AllManagePageSitePublisher: "view-all-user",
  ViewManagePageSitePublisher: "view-all-user",
  AllPositionInPage: "view-all-user",
  ViewPosition: "view-all-user",
  AllMessage: "view-all-user",
  AllPositionIndependentInSitePublisher: "view-all-user",
  ViewPositionIndependent: "view-all-user",
  AllIndependentPositionMessage: "view-all-user",
  ManageReportPosition: "view-all-user",
  
  AllUserPublisher: "view-all-user",
  ManageAllAskTransaction: "view-all-user",
  ManageInfoAskTransaction: "view-all-user",
  AllLogWalletPublisher: "view-all-user",
  AllLogScorePublisher: "view-all-user",
  AllTransactionManually: "view-all-user",
  AddTransactionManually: "view-all-user",
  ManageAllWalletLogPosition: "view-all-user",
  ManageAllScoreLogPosition: "view-all-user",
  AllTransactionScoreToWalletAdvertiser: "view-all-user",
};

const listPermissionItemMenu = {};

const listPermissionMenu = {};

const isUserHasPermission = (componentName, permissionsUser) => {
  if (!permissionsUser.includes(listPermissionNameComponent[componentName])) {
    return false;
  }

  return true;
};

const isUserHasPermissionTreeMenu = (permissions, permissionsUser) => {
  return permissions.some((val) => permissionsUser.indexOf(val) !== -1);
};

const isUserHasPermissionItemMenu = (
  permissions,
  permissionsUser,
  tagsItem
) => {
  const permissionItemMenu = listPermissionItemMenu[permissions];

  let resultCompare = permissionItemMenu.some(
    (permission) => permissionsUser.indexOf(permission) === -1
  );

  return !resultCompare ? tagsItem : "";
};

export default {
  isUserHasPermission,
  isUserHasPermissionTreeMenu,
  listPermissionMenu,
  isUserHasPermissionItemMenu,
};
